(() => {
 'use strict';
 if (customElements.get('ud-holiday-page')) return;
 class HolidayPage extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   const {signal} = this.controller;
   const phase = this.dataset.phase;
   const track = data => (window.dataLayer = window.dataLayer || []).push({campaign:'holiday_2026',phase,...data});
   if (!window.Shopify?.designMode) track({event:'holiday_landing_view'});
   let selected = [0,1];
   this.addEventListener('change', event => {
    const control = event.target.closest('[data-compare-slot]');
    if (!control) return;
    const slot = Number(control.dataset.compareSlot), next = Number(control.value);
    if (!Number.isInteger(next) || next < 0 || next > 3) return;
    if (selected[1-slot] === next) selected[1-slot] = selected[slot];
    selected[slot] = next;
    selected.forEach((index, position) => {
     this.querySelector(`[data-compare-slot="${position}"]`).value = String(index);
     const template = this.querySelector(`[data-compare-template="${index}"]`);
     const header = this.querySelector(`[data-compare-header="${position}"]`);
     header.replaceChildren(template.content.cloneNode(true));
    });
    // Keep visual column order identical to selector order, even when selections swap.
    this.querySelectorAll('.spring-mobile-table tr').forEach(row => {
     const columns = [...row.querySelectorAll('[data-compare-column]')];
     columns.forEach(column => { column.hidden = !selected.includes(Number(column.dataset.compareColumn)); });
     selected.forEach(index => {
      const column = columns.find(cell => Number(cell.dataset.compareColumn) === index);
      if (column) row.append(column);
     });
    });
    const names = selected.map(index => this.querySelector(`[data-compare-slot="0"] option[value="${index}"]`).textContent);
    this.querySelector('.spring-live').textContent = `Comparing ${names.join(' and ')}`;
   }, {signal});
   this.addEventListener('click', event => {
    const a = event.target.closest('a');
    if (!a) return;
    if (a.dataset.product) track({event:'holiday_product_click',product_id:a.dataset.product,placement:a.dataset.position,destination:a.href});
    else if (a.dataset.review) track({event:'holiday_review_click',video_id:a.dataset.review,destination:a.href});
   }, {signal});
   if ('IntersectionObserver' in window) {
    const links = [...this.querySelectorAll('.sale-nav a')];
    this.observer = new IntersectionObserver(entries => {
     for (const entry of entries) if (entry.isIntersecting) links.forEach(a => a.classList.toggle('active',a.hash === '#'+entry.target.id));
    }, {rootMargin:'-10% 0px -65% 0px'});
    links.forEach(a => { const target = this.querySelector(a.hash); if (target) this.observer.observe(target); });
   }
  }
  disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
 }
 customElements.define('ud-holiday-page', HolidayPage);
})();
